import { render, staticRenderFns } from "./WalletsOverview.html?vue&type=template&id=06fa24db&scoped=true&external"
import script from "./WalletsOverview.js?vue&type=script&lang=js&external"
export * from "./WalletsOverview.js?vue&type=script&lang=js&external"
import style0 from "./WalletsOverview.vue?vue&type=style&index=0&id=06fa24db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa24db",
  null
  
)

export default component.exports